export const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3005',
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
    externalBaseUrl: process.env.REACT_APP_EXTERNAL_BASE_URL || 'http://localhost:3000',
    shopBaseUrl: process.env.REACT_APP_SHOP_BASE_URL || 'http://localhost:3000',
    cloudinaryUrl:
        process.env.REACT_APP_CLOUDINARY_URL ||
        'https://api.cloudinary.com/v1_1/dbb8ok0sa/image/upload',
    cloudinaryUploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'drgw2oti',
};
